import { Container, Group, Text, Image, Anchor } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import classes from './PublicFooter.module.css';

const data = [
  {
    title: 'Product',
    links: [
      { label: 'Pricing', link: '/#pricing', isAnchor: true },
      { label: 'Features', link: '/#features', isAnchor: true },
      { label: 'Resources', link: '/resources' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', link: '/about' },
      { label: 'Contact', link: 'https://practist.io' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', link: 'https://practist.io/privacy' },
      { label: 'Terms of Service', link: 'https://practist.io/terms' },
    ],
  },
];

const PublicFooter = () => {
  const navigate = useNavigate();

  const groups = data.map((group) => {
    const links = group.links.map((link, index) => {
      const isExternal = link.link.startsWith('http');
      const isAnchor = link.isAnchor || link.link.includes('#');

      if (isExternal) {
        return (
          <Anchor
            key={index}
            className={classes.link}
            href={link.link}
            target='_blank'
            rel='noopener noreferrer'
            style={{ position: 'relative', zIndex: 101 }}
          >
            {link.label}
          </Anchor>
        );
      }

      if (isAnchor) {
        return (
          <Anchor
            key={index}
            className={classes.link}
            href={link.link}
            style={{ position: 'relative', zIndex: 101 }}
          >
            {link.label}
          </Anchor>
        );
      }

      // Internal route - use Link directly
      return (
        <Link
          key={index}
          to={link.link}
          className={classes.link}
          style={{ position: 'relative', zIndex: 101 }}
        >
          {link.label}
        </Link>
      );
    });

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner} size='lg'>
        <div className={classes.logo}>
          <Image
            src='/main-logo.webp'
            alt='Practist Logo'
            h={{ base: 30, md: 75 }}
            w={{ base: 120, md: 'auto' }}
            style={{ marginBottom: '5px' }}
            fit='contain'
          />
          <Text size='xs' c='dimmed' className={classes.description}>
            Law firm software you love using.
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter} size='lg'>
        <Text c='dimmed' size='sm'>
          © 2026 Practist, Inc. All rights reserved.
        </Text>
      </Container>
    </footer>
  );
};

export default PublicFooter;
